import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { AdminMetersDataType } from '@/entities/Cabinet/AdminMeters/model/types'
import useValidate from '@/shared/lib/validate'

const useModel = defineStore('cabinet_admin_meters_form', () => {
  const openForm = ref(false)
  const replaceId = ref(0)
  const { required, numberMin, isMeterAddress } = useValidate()

  /* Данные формы */
  const fields: AdminMetersDataType = {
    id: 0,
    order_number: null,
    meter_type_id: 8,
    serial_number: '',
    rs_address: '',
    tariff_count: 4,
    ktt: 1,
    is_password_use: false,
    password: '',
  }

  const data = ref({ ...fields })

  /* Правила валидации */
  const rules = {
    serial_number: [(value: string) => required(value)],
    tariff_count: [(value: number) => required(value), (value: number) => numberMin(value, 1)],
    address: (metersCount: number) => [(value: string) => isMeterAddress(value, metersCount)],
  }

  /**
   * Функция очистки формы после закрытия
   */
  const closeForm = () => {
    openForm.value = false
    replaceId.value = 0
    data.value = { ...fields }
  }

  return {
    data,
    fields,
    rules,
    replaceId,

    openForm,
    closeForm,
  }
})

export { useModel }
